<template>
  <!-- Loading -->
  <div v-if="loading" class="d-flex justify-center" style="margin-top: 10%;">
    <Loader />
  </div>

  <!-- PreAuths found -->
  <v-container
    v-else-if="treatments.length"
    fluid
    class="py-4 px-2 treatments-container"
  >
    <v-row dense>
      <!-- Title -->
      <v-col cols="12" class="mb-3">
        <v-card-title class="text-h6 font-weight-bold">
          PreAuths Details
        </v-card-title>
      </v-col>

      <!-- Treatment rows -->
      <v-col
        cols="12"
        v-for="(treatment, index) in treatments"
        :key="index"
      >
        <div class="d-flex align-center">
          <span v-if="treatment.ToothNum" class="mr-2">
            <v-icon small class="mr-1">mdi-tooth-outline</v-icon>
            {{ treatment.ToothNum }}
          </span>
          <span>{{ treatment.ItemName || '—' }}</span>
          <v-tooltip :text="`Status: ${treatment.ItemName1 || '—'}`">
            <template #activator="{ props }">
              <v-chip
                v-bind="props"
                :color="getStatusColor(treatment.ItemName1)"
                text-color="white"
                small
              >
                <v-icon left>
                  {{ treatment.ItemName1?.toLowerCase() === 'approved' ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </v-chip>
            </template>
          </v-tooltip>
        </div>
      </v-col>

      <!-- No results -->
      <v-col cols="12" v-if="!treatments.length">
        <v-alert type="info" text>
           No treatment details found.
        </v-alert>
      </v-col>
    </v-row>
  </v-container>

  <!-- No Open Dental Patient -->
  <div v-else class="d-flex justify-center align-center" style="min-height: 200px;">
    <p class="text-red-darken-4 bg-red-lighten-5 pa-4 rounded-lg text-center font-weight-medium">
      Contact is not an Open Dental patient.
    </p>
  </div>
</template>

<script>
import Loader from '../../UIComponents/Loader.vue';
import odService from '../../../services/odService';
import { mapGetters } from 'vuex';
import dayjsMixin from "../../../mixins/dayjsMixin";

export default {
  name: "PreAuthsDetails",
  components: { Loader },
  mixins: [dayjsMixin],
  props: {
    contact: { type: Object, required: true },
  },
  data() {
    return {
      treatments: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters("frontdesk", ["odData"]),
  },
  watch: {
    contact: {
      immediate: true,
      handler(newContact) {
        if (newContact?.contact_id) {
          this.fetchTreatments(newContact);
        } else {
          this.treatments = [];
        }
      },
    },
  },
  methods: {
    async fetchTreatments(contact) {
      const matched = this.odData.find(
        item => item.contact_id === contact.contact_id
      );

      if (!matched?.od_json || matched.od_json.length === 0) {
        console.warn("No matched record for contact_id:", contact.contact_id);
        this.treatments = [];
        return;
      }

      this.loading = true;
      try {
        const res = await odService.PreAuthsDetails(matched.od_json[0].PatNum);
        this.treatments = res?.data?.data?.[0]?.od_json || [];
      } catch (err) {
        console.error("Failed to fetch treatments:", err);
        this.treatments = [];
      } finally {
        this.loading = false;
      }
    },
    getStatusColor(status) { 
      if (!status) return "grey lighten-1"; 
      switch (status.toLowerCase()) {
         case "approved": 
         return "green darken-2";
          case "denied": 
          return "red darken-2"; 
          default:
             return "grey lighten-1"; } 
            },
  },
  beforeUnmount(){
    this.loading = false;
    this.treatments = [];
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 14px !important;
}

.treatments-container {
  max-height: 600px;
  overflow-y: auto;
}

.treatments-container::-webkit-scrollbar {
  width: 6px;
}
.treatments-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.treatments-container::-webkit-scrollbar-track {
  background: transparent;
}
</style>
